var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",style:(!_vm.padding ? 'px-0 py-0': '')},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }